var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "both-pd-box" }, [
    _c(
      "div",
      {
        staticStyle: {
          background: "#fff",
          padding: "30px",
          "border-radius": "20px",
        },
      },
      [
        _c(
          "el-tabs",
          {
            on: { "tab-click": _vm.handleClick },
            model: {
              value: _vm.activeName,
              callback: function ($$v) {
                _vm.activeName = $$v
              },
              expression: "activeName",
            },
          },
          [
            _c(
              "el-tab-pane",
              { attrs: { label: "登录页配置", name: "1" } },
              [
                _c(
                  "el-form",
                  {
                    ref: "ruleForm11",
                    staticClass: "demo-ruleForm",
                    staticStyle: { width: "60%" },
                    attrs: {
                      model: _vm.ruleForm,
                      rules: _vm.rules,
                      "label-width": "180px",
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticStyle: { "margin-top": "30px" },
                        attrs: { label: "App描述", prop: "appDescription" },
                      },
                      [
                        _c("el-input", {
                          attrs: { type: "textarea", rows: 4, clearable: "" },
                          model: {
                            value: _vm.ruleForm.appDescription,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "appDescription", $$v)
                            },
                            expression: "ruleForm.appDescription",
                          },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "tips" }, [
                          _vm._v("登录页APP图标下的宣传标语文字"),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        staticStyle: { width: "50%" },
                        attrs: {
                          label: "APP描述文字色",
                          prop: "appDescriptionColor",
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "space-between",
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: { type: "text" },
                              model: {
                                value: _vm.ruleForm.appDescriptionColor,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.ruleForm,
                                    "appDescriptionColor",
                                    $$v
                                  )
                                },
                                expression: "ruleForm.appDescriptionColor",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-color-picker", {
                              model: {
                                value: _vm.ruleForm.appDescriptionColor,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.ruleForm,
                                    "appDescriptionColor",
                                    $$v
                                  )
                                },
                                expression: "ruleForm.appDescriptionColor",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        staticStyle: { width: "100%" },
                        attrs: { label: "APP引导图", prop: "guideMaps" },
                      },
                      [
                        _c(
                          "el-upload",
                          {
                            attrs: {
                              limit: 3,
                              action: "",
                              "list-type": "picture-card",
                              "on-remove": function (value) {
                                return _vm.handleRemove(value, 1)
                              },
                              "show-file-list": true,
                              "file-list": _vm.ruleForm.guideMaps,
                              "http-request": function (value) {
                                return _vm.handleFileUpload_guideMaps(value)
                              },
                            },
                          },
                          [_c("i", { staticClass: "el-icon-plus" })]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "tips" }, [
                          _vm._v(
                            "\n              建议3张尺寸1080*1920PNG图片(首次下载APP登录时展示)\n            "
                          ),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        staticStyle: { width: "50%" },
                        attrs: {
                          label: "登录页面背景图",
                          prop: "appLoginBackgroundImage",
                        },
                      },
                      [
                        _c("upload", {
                          attrs: {
                            name: "appLoginBackgroundImage",
                            "img-url": _vm.ruleForm.appLoginBackgroundImage,
                          },
                          on: {
                            pictureAddress: function ($event) {
                              return _vm.onPictureAddress($event)
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "tips" }, [
                          _vm._v("建议尺寸750*620 PNG图片(商品信息加载前展示)"),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "一键登录功能",
                          prop: "uniConfig.uniStatus",
                        },
                      },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.ruleForm.uniConfig.uniStatus,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.ruleForm.uniConfig,
                                  "uniStatus",
                                  $$v
                                )
                              },
                              expression: "ruleForm.uniConfig.uniStatus",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: 1 } }, [
                              _vm._v("打开"),
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: 0 } }, [
                              _vm._v("关闭"),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "tips" }, [
                          _vm._v(
                            "使用一键登录功能前，请先查看是否完成极光推送相关基础配置"
                          ),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "blue",
                                "text-decoration": "underline",
                                cursor: "pointer",
                                "margin-left": "5px",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.jump("https://www.jiguang.cn")
                                },
                              },
                            },
                            [_vm._v("点击跳转>>")]
                          ),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.ruleForm.uniConfig.uniStatus === 1
                      ? _c(
                          "div",
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "RSA加密私钥" } },
                              [
                                _c("el-input", {
                                  attrs: {
                                    type: "textarea",
                                    rows: 4,
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.ruleForm.uniConfig.privateKey,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.ruleForm.uniConfig,
                                        "privateKey",
                                        $$v
                                      )
                                    },
                                    expression: "ruleForm.uniConfig.privateKey",
                                  },
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "tips" }, [
                                  _vm._v(
                                    "此私钥需从极光推送后台获取；若在极光重置密钥，必须立即更新此私钥 (无需重新打包)，否则一键登录失效！"
                                  ),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "一键登录按钮图" } },
                              [
                                !_vm.ruleForm.uniConfig.oneLoginButtonImage
                                  ? _c(
                                      "el-upload",
                                      {
                                        staticClass: "avatar-uploader",
                                        attrs: {
                                          "show-file-list": false,
                                          action: "",
                                          "http-request": function (value) {
                                            return _vm.handleFileUpload(
                                              value,
                                              "oneClickBtn.png"
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "el-icon-plus avatar-uploader-icon",
                                          staticStyle: {
                                            border: "1px dashed #c0ccda",
                                          },
                                        }),
                                      ]
                                    )
                                  : _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          width: "200px",
                                          position: "relative",
                                        },
                                      },
                                      [
                                        _c("el-image", {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            fit: "scale-down",
                                            src:
                                              _vm.ruleForm.uniConfig
                                                .oneLoginButtonImage +
                                              "?pic=" +
                                              Math.random(),
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("i", {
                                          staticClass: "el-icon-error",
                                          staticStyle: {
                                            position: "absolute",
                                            right: "-25px",
                                            top: "-8px",
                                            "font-size": "25px",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.delPic()
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                _vm._v(" "),
                                _c("div", { staticClass: "tips" }, [
                                  _vm._v(
                                    "建议尺寸600*96 png格式 带圆角纯色图片（不配置则使用默认图片）"
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "微信登录功能",
                          prop: "wechatLoginConfig.wechatStatus",
                        },
                      },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value:
                                _vm.ruleForm.wechatLoginConfig.wechatStatus,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.ruleForm.wechatLoginConfig,
                                  "wechatStatus",
                                  $$v
                                )
                              },
                              expression:
                                "ruleForm.wechatLoginConfig.wechatStatus",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: 1 } }, [
                              _vm._v("打开"),
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: 0 } }, [
                              _vm._v("关闭"),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticStyle: { color: "red" } }, [
                          _vm._v(
                            "\n              注意!微信登录下面相关参数修改调整后，需重新打包后才可生效，请勿随意到微信开放平台重置参数!\n            "
                          ),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.ruleForm.wechatLoginConfig.wechatStatus === 1
                      ? _c(
                          "div",
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "微信开放平台 APPID",
                                  prop: "wechatLoginConfig.wechatAppId",
                                },
                              },
                              [
                                _c("el-input", {
                                  model: {
                                    value:
                                      _vm.ruleForm.wechatLoginConfig
                                        .wechatAppId,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.ruleForm.wechatLoginConfig,
                                        "wechatAppId",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "ruleForm.wechatLoginConfig.wechatAppId",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "微信开放平台App Serect",
                                  prop: "wechatLoginConfig.wechatAppSecret",
                                },
                              },
                              [
                                _c("el-input", {
                                  model: {
                                    value:
                                      _vm.ruleForm.wechatLoginConfig
                                        .wechatAppSecret,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.ruleForm.wechatLoginConfig,
                                        "wechatAppSecret",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "ruleForm.wechatLoginConfig.wechatAppSecret",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "开放平台UniversalLinks" } },
                              [
                                _c(
                                  "div",
                                  { staticClass: "flex" },
                                  [
                                    _c("el-input", {
                                      attrs: { disabled: "" },
                                      model: {
                                        value:
                                          _vm.ruleForm.wechatLoginConfig
                                            .wechatUniversalLinks,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.ruleForm.wechatLoginConfig,
                                            "wechatUniversalLinks",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "ruleForm.wechatLoginConfig.wechatUniversalLinks",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "ml10",
                                        staticStyle: { height: "39px" },
                                        attrs: { type: "primary" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.copyText(
                                              _vm.ruleForm.wechatLoginConfig
                                                .wechatUniversalLinks
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("复制")]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "鸿蒙一键登录ClientId" } },
                              [
                                _c("el-input", {
                                  model: {
                                    value: _vm.ruleForm.uniConfig.hmClientId,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.ruleForm.uniConfig,
                                        "hmClientId",
                                        $$v
                                      )
                                    },
                                    expression: "ruleForm.uniConfig.hmClientId",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "鸿蒙一键登录ClientSecret" } },
                              [
                                _c("el-input", {
                                  model: {
                                    value:
                                      _vm.ruleForm.uniConfig.hmClientSecret,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.ruleForm.uniConfig,
                                        "hmClientSecret",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "ruleForm.uniConfig.hmClientSecret",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { staticStyle: { "margin-top": "60px" } },
                      [
                        _c(
                          "el-button",
                          {
                            staticStyle: { width: "200px" },
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.submitForm("ruleForm11")
                              },
                            },
                          },
                          [_vm._v("保存")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-tab-pane",
              { attrs: { label: "登录滑块验证", name: "2" } },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      padding: "10px 10px 10px 20px",
                      "line-height": "26px",
                      color: "#F59A23",
                      background: "#D9EDF7",
                    },
                  },
                  [
                    _vm._v(
                      "为防止恶意攻击，可开启登录时的滑块安全验证，需前往阿里云付费开通相关服务后才可使用"
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-form",
                  {
                    ref: "slid_ruleForm",
                    staticClass: "demo-ruleForm",
                    staticStyle: { width: "60%" },
                    attrs: {
                      model: _vm.slid_ruleForm,
                      rules: _vm.slid_rules,
                      "label-width": "280px",
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "登录滑块安全验证 " } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.slid_ruleForm.verifySwitch,
                              callback: function ($$v) {
                                _vm.$set(_vm.slid_ruleForm, "verifySwitch", $$v)
                              },
                              expression: "slid_ruleForm.verifySwitch",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: 1 } }, [
                              _vm._v("打开"),
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: 0 } }, [
                              _vm._v("关闭"),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "tips" }, [
                          _vm._v(
                            "为防止恶意攻击，可开启登录时的滑块安全验证，需前往阿里云付费开通相关服务后才可使用"
                          ),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "Sceneld(场景ID)", prop: "sceneId" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入内容", clearable: "" },
                          model: {
                            value: _vm.slid_ruleForm.sceneId,
                            callback: function ($$v) {
                              _vm.$set(_vm.slid_ruleForm, "sceneId", $$v)
                            },
                            expression: "slid_ruleForm.sceneId",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "Prefix(身份标)", prop: "prefix" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入内容", clearable: "" },
                          model: {
                            value: _vm.slid_ruleForm.prefix,
                            callback: function ($$v) {
                              _vm.$set(_vm.slid_ruleForm, "prefix", $$v)
                            },
                            expression: "slid_ruleForm.prefix",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "Ekey(加密密钥)", prop: "Ekey" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入内容", clearable: "" },
                          model: {
                            value: _vm.slid_ruleForm.Ekey,
                            callback: function ($$v) {
                              _vm.$set(_vm.slid_ruleForm, "Ekey", $$v)
                            },
                            expression: "slid_ruleForm.Ekey",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "AccessKeyID(访问授权ID)",
                          prop: "AccessKeyID",
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入内容", clearable: "" },
                          model: {
                            value: _vm.slid_ruleForm.AccessKeyID,
                            callback: function ($$v) {
                              _vm.$set(_vm.slid_ruleForm, "AccessKeyID", $$v)
                            },
                            expression: "slid_ruleForm.AccessKeyID",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "AccessKey Secret(访问授权Secret)",
                          prop: "AccessKeySecret",
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入内容", clearable: "" },
                          model: {
                            value: _vm.slid_ruleForm.AccessKeySecret,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.slid_ruleForm,
                                "AccessKeySecret",
                                $$v
                              )
                            },
                            expression: "slid_ruleForm.AccessKeySecret",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { staticStyle: { "margin-top": "60px" } },
                      [
                        _c(
                          "el-button",
                          {
                            staticStyle: { width: "200px" },
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.slid_ruleForm_submitForm(
                                  "slid_ruleForm"
                                )
                              },
                            },
                          },
                          [_vm._v("保存")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }